"use strict";

import angular from "angular";
import _ from "lodash";
import { Accounting } from "../../gateway/Accounting/Accounting";
import { User } from "../../gateway/User/User";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { Events } from "../../presentation/services/Events/Events";
import selectCompaniesImportTypeDialogTemplate from "../dialogs/select-companies-import-type/select-companies-import-type-dialog.html";

export class JourneyService {
    Accounting = new Accounting();
    User = new User();
    Events = new Events();
    user = new UserDataAdapter().user();
    systems = {
        accounting: [
            {
                name: "Domínio Sistemas",
                icon: "assets/images/integration/dominio.svg",
                value: "dominio",
                api: true,
                priority: 1,
                state: {
                    uisref: "nucont.accounting.integration.dominioideen",
                    params: {
                        source: "contabil",
                        from: "journey"
                    }
                },
                roles: ["Contabil", "Pessoal e Fiscal", "Fiscal", "Pessoal"]
            },
            {
                name: "Fortes",
                icon: "assets/images/integration/fortes.svg",
                value: "fortes",
                api: true,
                priority: 4,
                state: {
                    uisref: "nucont.accounting.integration.fortes",
                    params: {
                        source: "contabil",
                        from: "journey"
                    }
                }
            },
            {
                name: "Alterdata",
                icon: "assets/images/integration/io1.svg",
                value: "alterdata",
                doc:
                    "https://ajuda.nucont.com/hubfs/Importando_balancetes_pelo_Alterdata%20%202024.pdf"
            },
            {
                name: "Athenas",
                icon: "assets/images/integration/athenas.svg",
                value: "athenas",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_athenas.pdf"
            },
            {
                name: "CISS",
                icon: "assets/images/integration/ciss.svg",
                value: "ciss",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_ciss.pdf"
            },
            {
                name: "Cognum",
                icon: "assets/images/integration/cognum.svg",
                value: "cognum"
            },
            {
                name: "Contabit",
                icon: "assets/images/integration/contabit.svg",
                value: "contabit",
                api: true,
                priority: 5,
                state: {
                    uisref: "nucont.accounting.integration.contabit",
                    params: {
                        source: "contabil",
                        from: "journey"
                    }
                }
            },
            {
                name: "Contmatic",
                icon: "assets/images/integration/contmatic.svg",
                value: "contmatic",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_contmatic%20(2).pdf"
            },
            {
                name: "Cordilheira",
                icon: "assets/images/integration/cordilheira.svg",
                value: "cordilheira",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_cordilheira.pdf"
            },
            {
                name: "DP_Comp",
                icon: "assets/images/integration/dpcomp.svg",
                value: "dpcomp",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_dpcomp.pdf"
            },
            {
                name: "E-Contab",
                icon: "assets/images/integration/econtab.svg",
                value: "econtab",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_e_contab.pdf"
            },
            {
                name: "Folhamatic",
                icon: "assets/images/integration/folhamatic.svg",
                value: "folhamatic",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_folhamatic.pdf"
            },
            {
                name: "Intsys",
                icon: "assets/images/integration/intsys.svg",
                value: "intsys",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_intsys.pdf"
            },
            {
                name: "MasterMaq",
                icon: "assets/images/integration/mastermaq.svg",
                value: "mastermaq",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pela_mastermaq%20(1).pdf"
            },
            {
                name: "Nasajon",
                icon: "assets/images/integration/nasajon.svg",
                value: "nasajon",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_nasajon-1.pdf"
            },
            {
                name: "Netspeed",
                icon: "assets/images/integration/netspeed.svg",
                value: "netspeed",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_netspeed.pdf"
            },
            {
                name: "Prosoft",
                icon: "assets/images/integration/prosoft.svg",
                value: "prosoft",
                doc:
                    "https://ajuda.nucont.com/hubfs/Central%20do%20Conhecimento%20Materiais/Importando%20balancetes%20pelo%20Prosoft.pdf"
            },
            {
                name: "Questor",
                icon: "assets/images/integration/io2.svg",
                value: "questor",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_questor%20(1).pdf"
            },
            {
                name: "SCI_contabil_unico",
                icon: "assets/images/integration/sci.svg",
                value: "sci",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_sci%202024-1.pdf"
            },
            {
                name: "Wireline",
                icon: "assets/images/integration/wireline.svg",
                value: "wireline",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_wireline.pdf"
            },
            {
                name: "WK_Radar",
                icon: "assets/images/integration/wk.svg",
                value: "wk",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_wk_radar.pdf"
            },
            {
                name: "CV_Soft",
                icon: "assets/images/integration/cvsoft.svg",
                value: "cvsoft",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_cv_soft.pdf"
            },
            {
                name: "Dexion",
                icon: "assets/images/integration/dexion.svg",
                value: "dexion",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_dexion.pdf"
            },
            {
                name: "Lider_W",
                icon: "assets/images/integration/liderw.svg",
                value: "liderw",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_lider_w.pdf"
            },
            {
                name: "Memphis",
                icon: "assets/images/integration/memphis.svg",
                value: "memphis",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_memphis.pdf"
            },
            {
                name: "Sage",
                icon: "assets/images/integration/sage.svg",
                value: "sage",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_sage%20(2).pdf"
            },
            {
                name: "SCI_visual_sucessor",
                icon: "assets/images/integration/scivisual.svg",
                value: "scivisual",
                doc:
                    "https://ajuda.nucont.com/hubfs/importando_balancetes_pelo_sci_visual_sucessor.pdf"
            }
        ],
        fin: [
            {
                name: "Conta Azul",
                icon: "assets/images/integration/conta-azul-logo-new.svg",
                value: "contaazul",
                api: true,
                priority: 3,
                state: {
                    uisref: "nucont.accounting.integration.contaazul",
                    params: {
                        source: "financeiro",
                        from: "journey"
                    }
                }
            },
            {
                name: "Nibo",
                icon: "assets/images/integration/nibo-integration-icon.png",
                value: "nibo",
                api: true,
                priority: 2,
                state: {
                    uisref: "nucont.accounting.integration.nibo",
                    params: {
                        source: "financeiro",
                        from: "journey"
                    }
                }
            },
            {
                name: "Omie",
                icon: "assets/images/integration/omie.svg",
                value: "omie",
                api: true
            },
            {
                name: "Tottvs",
                icon: "assets/images/integration/tottvs.svg",
                value: "tottvs"
            },
            {
                name: "Tiny ERP",
                icon: "assets/images/integration/tinyerp.svg",
                value: "tinyerp"
            },
            {
                name: "Sensio ERP",
                icon: "assets/images/integration/sensioerp.svg",
                value: "sensioerp"
            },
            {
                name: "GestãoClick",
                icon: "assets/images/integration/gestaoclick.svg",
                value: "gestaoclick"
            },
            {
                name: "Bling",
                icon: "assets/images/integration/bling.svg",
                value: "bling"
            },
            {
                name: "Senior ERP",
                icon: "assets/images/integration/seniorerp.svg",
                value: "seniorerp"
            },
            {
                name: "Bom Controle",
                icon: "assets/images/integration/bomcontrole.svg",
                value: "bomcontrole"
            },
            {
                name: "Meu Dinheiro",
                icon: "assets/images/integration/meudinheiro.svg",
                value: "meudinheiro"
            },
            {
                name: "Yampa (4blue)",
                icon: "assets/images/integration/yampa.svg",
                value: "yampa"
            },
            {
                name: "Erp4me (Alterdata)",
                icon: "assets/images/integration/erp4me.svg",
                value: "erp4me"
            },
            {
                name: "Aegro",
                icon: "assets/images/integration/aegro.svg",
                value: "aegro"
            }
        ],
        eSocial: [
            {
                name: "eSocial",
                icon: "assets/images/integration/esocial-logo.png",
                value: "eSocial",
                gov: true,
                api: true,
                state: {
                    uisref: "nucont.accounting.integration.eSocial",
                    params: {
                        source: "pessoal",
                        from: "journey"
                    }
                },
                roles: ["Pessoal", "Pessoal e Fiscal"]
            }
        ],
        simplesNacional: [
            {
                name: "PGDAS",
                icon: "/assets/images/integration/pgdas.svg",
                value: "serpro",
                gov: true,
                api: true,
                state: {
                    uisref: "nucont.accounting.integration.serpro",
                    params: {
                        source: "fiscal",
                        from: "journey"
                    }
                },
                roles: ["Fiscal", "Pessoal e Fiscal"]
            }
        ],
        others: [
            {
                name: "Outros",
                icon: "assets/icons/icon-integration-gray.svg",
                value: "others"
            },
            {
                name: "Nenhum",
                icon: "assets/icons/icon-integration-gray.svg",
                value: "none"
            }
        ],
        manual: [
            {
                name: "Tabela Nucont",
                icon: "assets/images/nucont-table.svg",
                value: "tableNucont",
                priority: 998,
                state: {
                    uisref: "nucont.accounting.journey.import.manualTable",
                    params: {
                        from: "journey"
                    }
                }
            },
            {
                name: "Importar Excel",
                icon: "assets/icons/excel.svg",
                value: "importExcel",
                priority: 999,
                state: {
                    uisref: "nucont.accounting.journey.import.spreadsheet",
                    params: {
                        from: "journey"
                    }
                }
            }
        ]
    };
    allowedSystems = {
        dominio: true,
        fortes: true,
        contabit: true,
        contaazul: true,
        nibo: true,
        tableNucont: true,
        importExcel: true
    };
    steps = ["STARTED", "SYSTEM_DEFINED", "COMPLETED"];
    currentToastFlowStep = null;
    notRequiredToastFlowStep = ["INVITE_USERS", "ADD_CONTACTS", "AUTOMATION"];
    dontHaveSystem = false;
    accountingSystem = null;
    financialSystems = [];
    systemsPriority = [];
    mainPriority = null;
    step = "STARTED";

    constructor(toast, $state, DesnuDialogService, AccountingDataService, $injector) {
        this.toast = toast;
        this.$state = $state;
        this.DesnuDialogService = DesnuDialogService;
        this.AccountingDataService = AccountingDataService;
        this.$injector = $injector;
    }

    configSystemsByPreferences(mySystems, onboardingStep) {
        this.setStep(onboardingStep || this.step || "SYSTEM_DEFINED");
        if (!mySystems?.accounting?.length && !mySystems?.financial?.length)
            return;
        this.configAccountingSystem(mySystems.accounting);
        this.configFinancialSystems(mySystems.financial);
        this.setSystemsPriority();
    }

    configAccountingSystem(accountingConfig) {
        if (!accountingConfig?.length) return;
        const accountingSystem = accountingConfig[0].value;
        if (["others", "none"].includes(accountingSystem)) {
            const system = this.systems.others.find(
                (system) => system.value === accountingSystem
            );
            this.setAccountingSystem(system);
        } else {
            const system = this.systems.accounting.find(
                (system) => system.value === accountingSystem
            );
            this.setAccountingSystem(system);
        }
    }

    configFinancialSystems(financialConfig) {
        if (!financialConfig?.length) return;
        const financialSystem = financialConfig[0].value;
        if (["others", "none"].includes(financialSystem)) {
            const noneSystem = this.systems.others.find(
                (system) => system.value === financialSystem
            );
            this.setFinancialSystems([noneSystem]);
        } else {
            const financialSystems = this.systems.fin.filter((system) =>
                financialConfig.find((s) => s.value === system.value)
            );
            this.setFinancialSystems(financialSystems);
        }
    }

    setSystemsPriority() {
        const systemsPriority = [
            this.accountingSystem,
            ...this.financialSystems,
            ...this.systems.manual
        ]
            .map((system) => {
                return {
                    ...system,
                    priority: system?.priority || 1000
                };
            })
            .filter((system) => !["others", "none"].includes(system.value))
            .sort((a, b) => a.priority - b.priority);
        const hasSystemWithAPIAllowed = systemsPriority.some(
            (system) => system.api && this.allowedSystems[system.value]
        );
        if (hasSystemWithAPIAllowed) {
            this.systemsPriority = systemsPriority.filter(
                (system) => !["importExcel"].includes(system.value)
            );
        } else {
            this.systemsPriority = systemsPriority;
        }
        this.mainPriority = this.systemsPriority[0];
    }

    reorderSystemsPriority(system) {
        this.systemsPriority = this.systemsPriority.filter(
            (s) => s.value !== system.value
        );
        this.systemsPriority.unshift(system);
    }

    verifyNotHaveSystem() {
        if (
            this.accountingSystem?.value === "none" &&
            this.financialSystems?.find((system) => system.value === "none")
        ) {
            this.dontHaveSystem = true;
        }
    }

    afterChangeDontHaveSystem() {
        if (this.dontHaveSystem) {
            const noneSystem = this.systems.others.find(
                (system) => system.value === "none"
            );
            this.accountingSystem = noneSystem;
            this.financialSystems = [noneSystem];
        } else {
            this.accountingSystem = null;
            this.financialSystems = [];
        }
    }

    setAccountingSystem(system) {
        this.accountingSystem = system || null;
        this.verifyNotHaveSystem();
    }

    getAccountingSystem() {
        return this.accountingSystem;
    }

    setFinancialSystems(systems) {
        this.financialSystems = [...systems] || [];
        this.verifyNotHaveSystem();
    }

    getFinancialSystems() {
        return this.financialSystems;
    }

    getStartSystem() {
        return this.systemsPriority[0];
    }

    setStep(step) {
        this.step = this.steps.find((s) => s === step);
    }

    getStep() {
        return this.step;
    }

    isDefiningSystemStep() {
        return ["SYSTEM_DEFINED", "COMPLETED"].includes(this.step);
    }

    getMySystems() {
        let systems = [];
        if (this.accountingSystem) {
            systems.push({
                ...this.accountingSystem,
                category: ["Contábil"],
                roles: this.accountingSystem.roles || ["Contabil"]
            });
        }
        const financial = this.financialSystems.map((system) => {
            return {
                ...system,
                doc:
                    system.doc ||
                    "https://ajuda.nucont.com/centraldeconhecimento/input-de-dados-financeiros-2",
                category: ["Financeiro"],
                roles: system.roles || ["Financeiro"]
            };
        });
        systems.push(...financial);
        systems = this.filterSystemsByRoles(systems);
        return systems.filter(
            (system) => !["others", "none"].includes(system.value)
        );
    }

    filterSystemsByRoles(systems) {
        const user = new UserDataAdapter().user();
        if (
            user.roles.some((role) =>
                [
                    "Contabil",
                    "Pessoal e Fiscal",
                    "Fiscal",
                    "Pessoal",
                    "Financeiro"
                ].includes(role)
            )
        ) {
            return systems.filter((system) =>
                system.roles.some((role) => user.roles.includes(role))
            );
        } else {
            return systems;
        }
    }

    getNotUsedSystems() {
        const accounting = this.systems.accounting.map((system) => {
            return {
                ...system,
                category: ["Contábil"],
                roles: system.roles || ["Contabil"]
            };
        });
        const financial = this.systems.fin.map((system) => {
            return {
                ...system,
                doc:
                    system.doc ||
                    "https://ajuda.nucont.com/centraldeconhecimento/input-de-dados-financeiros-2",
                category: ["Financeiro"],
                roles: system.roles || ["Financeiro"]
            };
        });
        const mySystems = this.getMySystems().map((system) => system.value);
        let systems = [...accounting, ...financial].filter(
            (system) => !mySystems.includes(system.value)
        );
        return this.filterSystemsByRoles(systems);
    }

    getAllSystems() {
        const accounting = this.systems.accounting.map((system) => {
            return {
                ...system,
                category: ["Contábil"]
            };
        });
        const financial = this.systems.fin.map((system) => {
            return {
                ...system,
                category: ["Financeiro"]
            };
        });
        return [...accounting, ...financial];
    }

    getGovSystems() {
        const eSocial = this.systems.eSocial.map((system) => {
            return {
                ...system,
                category: ["Pessoal"],
                roles: system.roles || ["Pessoal", "Pessoal e Fiscal"]
            };
        });
        const simplesNacional = this.systems.simplesNacional.map((system) => {
            return {
                ...system,
                category: ["Fiscal"],
                roles: system.roles || ["Fiscal", "Pessoal e Fiscal"]
            };
        });
        let systems = [...eSocial, ...simplesNacional];
        return this.filterSystemsByRoles(systems);
    }

    getSystemsByValues(values) {
        return [
            ...this.systems.accounting,
            ...this.systems.fin,
            ...this.systems.eSocial,
            ...this.systems.simplesNacional
        ].filter((system) => values.includes(system.value));
    }

    getSystemsWithAPI(source) {
        if (source === "accounting") {
            return this.systems.accounting.filter((system) => system.api);
        } else if (source === "fin") {
            return this.systems.fin.filter((system) => system.api);
        } else {
            return [...this.systems.accounting, ...this.systems.fin].filter(
                (system) => system.api
            );
        }
    }

    hasSystemConfig() {
        return this.accountingSystem && this.financialSystems.length > 0;
    }

    async saveMySystemsAndStep(accountingId, onboarding) {
        if (!accountingId) return;
        const mySystems = this.getMySystemsSaveModel();
        await this.Accounting.updateMySystemsAndOnboarding({
            accountingId,
            mySystems,
            onboarding
        });
    }

    getMySystemsSaveModel() {
        return {
            accounting: [{ value: this.accountingSystem.value }],
            financial: this.financialSystems.map((system) => ({
                value: system.value
            }))
        };
    }

    async saveStep(accountingId, onboardingStep) {
        if (
            !accountingId ||
            !onboardingStep ||
            !this.steps.includes(onboardingStep)
        )
            return;
        await this.Accounting.updateOnboarding({
            accountingId,
            onboarding: onboardingStep
        });
    }

    openToastFlow(dataKpi, companiesTotal, fromAccounting) {
        const step = this.getToastStep(dataKpi, companiesTotal, fromAccounting);
        if (step) this.openToast(step, dataKpi);
        this.currentToastFlowStep = step;
    }

    getToastStep(dataKpi, companiesTotal, fromAccounting) {
        if (companiesTotal === 0) return "ADD_COMPANIES";
        const noData =
            dataKpi?.dataUpdate?.noData === 0
                ? 0
                : dataKpi?.dataUpdate?.noData - fromAccounting;
        if (companiesTotal === noData) return "ADD_DATA";
        if (
            dataKpi?.users?.employed <= 1 &&
            !this.user.profile?.featureFlag?.journeyInviteUsers
        )
            return "INVITE_USERS";
        if (
            companiesTotal === dataKpi?.contacts?.without - fromAccounting &&
            !this.user.profile?.featureFlag?.journeyAddContacts
        )
            return "ADD_CONTACTS";
        if (
            !dataKpi?.delivery?.schedule?.automatic?.length &&
            !dataKpi?.delivery?.schedule?.manual?.length &&
            !this.user.profile?.featureFlag?.journeyAutomation
        )
            return "AUTOMATION";
        return "";
    }

    openToastOmie() {
        const config = {
            message: `Passo 1 de 2 | Cadastre empresas na sua carteira para utilizar a integração com a Omie.`,
            buttons: {
                primary: {
                    label: `Adicionar empresas`,
                    action: () => {
                        this.Events.send(
                            `contabilidade.jornada.toast.omie.cadastrarempresas`
                        );
                        this.$state.go(
                            "nucont.accounting.journey.import.manualTable",
                            {
                                from: "omie"
                            }
                        );
                        this.toast.hide();
                    }
                }
            },
            extLocals: {
                rocket: true
            },
            after: {}
        };
        this.toast.snackbar(config);
    }

    openToast(step, dataKpi) {
        const steps = {
            ADD_COMPANIES: () => {
                const system = this.mainPriority;
                const buttons = {
                    withAPI: {
                        primary: {
                            label: `Integrar ${system?.name}`,
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionarempresas.integracao.${system.value}`
                                );
                                this.$state.go(system.state.uisref, {
                                    ...system.state.params,
                                    from: ""
                                });
                                this.toast.hide();
                            }
                        },
                        secondary: {
                            label: "Cadastrar manual",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionarempresas.cadastrarmanual`
                                );
                                this.openPopAddManualCompanies();
                                this.toast.hide();
                            }
                        }
                    },
                    withoutAPI: {
                        primary: {
                            label: `Adicionar empresas`,
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionarempresas.manual`
                                );
                                this.openPopAddManualCompanies();
                                this.toast.hide();
                            }
                        }
                    }
                };
                const config = {
                    message: `Passo 1 de ${
                        dataKpi?.integrations?.dominio?.total ? 3 : 2
                    } | Comece já! Adicione as empresas em sua carteira.`,
                    buttons: buttons[system?.api ? "withAPI" : "withoutAPI"],
                    extLocals: {
                        rocket: true
                    },
                    after: {}
                };
                return config;
            },
            ADD_DATA: () => {
                const config = {
                    message: `Passo 2 de ${
                        dataKpi?.integrations?.dominio?.total ? 3 : 2
                    } | Continue sua jornada! Insira os dados com o seu sistema de preferência.`,
                    buttons: {
                        primary: {
                            label: "Acessar Integrações",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionardados.integracoes`
                                );
                                this.toast.hide();
                                this.$state.go(
                                    "nucont.accounting.integrations"
                                );
                            }
                        },
                        secondary: {
                            label: "Talvez depois",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionardados.talvezdepois`
                                );
                                this.toast.hide();
                                if (
                                    !dataKpi?.integrations?.dominio?.total &&
                                    dataKpi?.users?.employed === 0 &&
                                    !this.user.profile?.featureFlag
                                        ?.journeyInviteUsers
                                ) {
                                    if (
                                        !this.user.profile?.featureFlag
                                            ?.journeyInviteUsers
                                    )
                                        this.openToast("INVITE_USERS", dataKpi);
                                    else
                                        this.openToast("ADD_CONTACTS", dataKpi);
                                } else {
                                    this.openToast("ADD_CONTACTS", dataKpi);
                                }
                            }
                        }
                    },
                    extLocals: {
                        rocket: true
                    },
                    after: {}
                };
                return config;
            },
            INVITE_USERS: () => {
                const config = {
                    message: `Convide seu time, cadastre os usuários.`,
                    buttons: {
                        primary: {
                            label: "Gestão de usuários",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.convideseutime.gestaodeusuarios`
                                );
                                this.toast.hide();
                                this.$state.go(
                                    "nucont.accounting.manager-users.employee"
                                );
                                this.updateFlag("journeyInviteUsers");
                            }
                        },
                        secondary: {
                            label: "Fechar",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.convideseutime.fechar`
                                );
                                this.toast.hide();
                                this.updateFlag("journeyInviteUsers");
                                if (
                                    !this.user.profile?.featureFlag
                                        ?.journeyAddContacts
                                )
                                    this.openToast("ADD_CONTACTS", dataKpi);
                                else if (
                                    !this.user.profile?.featureFlag
                                        ?.journeyAutomation
                                )
                                    this.openToast("AUTOMATION", dataKpi);
                            }
                        }
                    },
                    extLocals: {
                        rocket: true
                    },
                    after: {
                        then: (result) => {},
                        catch: (error) => {}
                    }
                };
                return config;
            },
            ADD_CONTACTS: () => {
                const config = {
                    message: `Adicione contatos no cadastro de empresas.`,
                    buttons: {
                        primary: {
                            label: "Contatos",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionarcontatos.contatos`
                                );
                                this.toast.hide();
                                this.$state.go(
                                    "nucont.accounting.overview.portfolio.companies.contacts"
                                );
                            }
                        },
                        secondary: {
                            label: "Fechar",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.adicionarcontatos.fechar`
                                );
                                this.toast.hide();
                                this.updateFlag("journeyAddContacts");
                                if (
                                    !this.user.profile?.featureFlag
                                        ?.journeyAutomation
                                )
                                    this.openToast("AUTOMATION", dataKpi);
                            }
                        }
                    },
                    extLocals: {
                        rocket: true
                    },
                    after: {
                        then: (result) => {},
                        catch: (error) => {}
                    }
                };
                return config;
            },
            AUTOMATION: () => {
                const config = {
                    message: `Agende a automação no envio de Dashes!`,
                    buttons: {
                        primary: {
                            label: "Automações",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.automacao.automacoes`
                                );
                                this.toast.hide();
                                this.$state.go(
                                    "nucont.accounting.reporting-center.automations"
                                );
                            }
                        },
                        secondary: {
                            label: "Fechar",
                            action: () => {
                                this.Events.send(
                                    `contabilidade.jornada.toast.automacao.fechar`
                                );
                                this.updateFlag("journeyAutomation");
                                this.toast.hide();
                            }
                        }
                    },
                    extLocals: {
                        rocket: true
                    },
                    after: {
                        then: (result) => {},
                        catch: (error) => {}
                    }
                };
                return config;
            }
        };
        if (step) {
            this.currentToastFlowStep = step;
            const config = steps[step]?.() || {};
            if (config) this.toast.snackbar(config);
        }
    }

    openPopAddManualCompanies() {
        this.DesnuDialogService.custom({
            controller: "SelectCompaniesImportTypeDialogCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                title: "Selecione uma forma para importar",
                width: "1000px",
                templateHtml: selectCompaniesImportTypeDialogTemplate
            },
            after: {}
        });
    }

    hasAnySystem() {
        if (!this.accountingSystem || !this.financialSystems) return false;
        return (
            !["others", "none"].includes(this.accountingSystem?.value) ||
            this.financialSystems.some(
                (system) => !["others", "none"].includes(system.value)
            )
        );
    }

    updateFlag(flag) {
        _.set(this.user.profile, "featureFlag." + flag, new Date());
        const accountingId = this.AccountingDataService.getEntity().props._id;
        this.User.saveMany(accountingId, [
            { _id: this.user._id, featureFlag: flag }
        ]);
    }

    reset() {
        this.dontHaveSystem = false;
        this.accountingSystem = null;
        this.financialSystems = [];
        this.systemsPriority = [];
        this.mainPriority = null;
        this.step = "STARTED";
    }

    currentIsNotRequiredToastFlowStep() {
        return this.notRequiredToastFlowStep.includes(
            this.currentToastFlowStep
        );
    }
}

angular
    .module("nucont.shared")
    .service("JourneyService", [
        "toast",
        "$state",
        "DesnuDialogService",
        "AccountingDataService",
        "$injector",
        JourneyService
    ]);
